import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Delete1"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.0312 2C10.0312 1.72386 9.80739 1.5 9.53125 1.5H6.46875C6.19261 1.5 5.96875 1.72386 5.96875 2V3.125H2C1.72386 3.125 1.5 3.34886 1.5 3.625V3.84375C1.5 4.11989 1.72386 4.34375 2 4.34375H14C14.2761 4.34375 14.5 4.11989 14.5 3.84375V3.625C14.5 3.34886 14.2761 3.125 14 3.125H10.0312V2ZM12.0625 4.75C12.5112 4.75 12.875 5.11377 12.875 5.5625V12.875C12.875 13.7725 12.1475 14.5 11.25 14.5H4.75C3.85254 14.5 3.125 13.7725 3.125 12.875V5.5625C3.125 5.11377 3.48877 4.75 3.9375 4.75H12.0625ZM6.17188 7.6875C6.17188 7.41136 6.39573 7.1875 6.67188 7.1875H6.89062C7.16677 7.1875 7.39062 7.41136 7.39062 7.6875V11.5625C7.39062 11.8386 7.16677 12.0625 6.89062 12.0625H6.67188C6.39573 12.0625 6.17188 11.8386 6.17188 11.5625V7.6875ZM9.10938 7.1875C8.83323 7.1875 8.60938 7.41136 8.60938 7.6875V11.5625C8.60938 11.8386 8.83323 12.0625 9.10938 12.0625H9.32812C9.60427 12.0625 9.82812 11.8386 9.82812 11.5625V7.6875C9.82812 7.41136 9.60427 7.1875 9.32812 7.1875H9.10938Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var delete1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { delete1 as default };
